import React from "react";

const LocationIcon = ({
  color = "#FFFF00",
  width = "40",
  height = "41"
}: {
  color?: string;
  width?: string | number;
  height?: string | number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0316 15.625C15.0316 12.6047 17.48 10.1562 20.5003 10.1562C23.5206 10.1562 25.9691 12.6047 25.9691 15.625C25.9691 18.6453 23.5206 21.0937 20.5003 21.0937C17.48 21.0937 15.0316 18.6453 15.0316 15.625ZM20.5003 12.3437C18.6881 12.3437 17.2191 13.8128 17.2191 15.625C17.2191 17.4372 18.6881 18.9062 20.5003 18.9062C22.3125 18.9062 23.7816 17.4372 23.7816 15.625C23.7816 13.8128 22.3125 12.3437 20.5003 12.3437Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9576 14.3522C11.3568 9.50879 15.4043 5.78125 20.2641 5.78125H20.7366C25.5964 5.78125 29.6438 9.50879 30.0431 14.3522C30.2571 16.9485 29.4551 19.5264 27.8061 21.5431L22.5637 27.9544C21.4973 29.2586 19.5034 29.2586 18.437 27.9544L13.1945 21.5431C11.5455 19.5264 10.7436 16.9484 10.9576 14.3522ZM20.2641 7.96875C16.5427 7.96875 13.4434 10.8231 13.1377 14.5319C12.9703 16.5633 13.5977 18.5804 14.888 20.1584L20.1304 26.5697C20.3216 26.8035 20.6791 26.8035 20.8703 26.5697L26.1127 20.1584C27.4029 18.5804 28.0304 16.5633 27.863 14.5319C27.5573 10.8231 24.458 7.96875 20.7366 7.96875H20.2641Z"
        fill={color}
      />
      <path
        d="M14.1869 26.3225C14.4571 25.7822 14.2381 25.1252 13.6978 24.855C13.1575 24.5849 12.5005 24.8039 12.2304 25.3442L9.31371 31.1775C9.14419 31.5166 9.16231 31.9192 9.36159 32.2417C9.56088 32.5641 9.91292 32.7604 10.292 32.7604H30.7087C31.0877 32.7604 31.4398 32.5641 31.6391 32.2417C31.8383 31.9192 31.8565 31.5166 31.6869 31.1775L28.7703 25.3442C28.5001 24.8039 27.8431 24.5849 27.3029 24.855C26.7626 25.1252 26.5436 25.7822 26.8137 26.3225L28.9389 30.5729H12.0617L14.1869 26.3225Z"
        fill={color}
      />
    </svg>
  );
}

export default LocationIcon;
